import { render, staticRenderFns } from "./RenShi6.vue?vue&type=template&id=7f04c856&scoped=true&"
import script from "./RenShi6.vue?vue&type=script&lang=js&"
export * from "./RenShi6.vue?vue&type=script&lang=js&"
import style0 from "./RenShi6.vue?vue&type=style&index=0&id=7f04c856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04c856",
  null
  
)

export default component.exports